import Service, { service } from '@ember/service';
import { task } from 'ember-concurrency';
import config from 'eflex/config/environment';
import { waitFor } from '@ember/test-waiters';

export default class EflexAjaxService extends Service {
  @service session;

  get = task(waitFor(async (route, params, accept) => {
    return await this._sendJsonRequest.perform('GET', this.getUrl(route, params), null, accept);
  }));

  post = task(waitFor(async (route, data, accept) => {
    return await this._sendJsonRequest.perform('POST', this.getUrl(route), data, accept);
  }));

  put = task(waitFor(async (route, data, accept) => {
    return await this._sendJsonRequest.perform('PUT', this.getUrl(route), data, accept);
  }));

  delete = task(waitFor(async route => {
    return await this._sendJsonRequest.perform('DELETE', this.getUrl(route));
  }));

  sendRawRequest = task(waitFor(async (url, type, data, accept) => {
    const options = this.getOptions(type, data, accept);
    const response = await fetch(url, options);

    if (this.session.isAuthenticated && response.status === 401) {
      await this.session.invalidate();
      return;
    }

    return response;
  }));

  _sendJsonRequest = task(waitFor(async (type, url, data, accept) => {
    const response = await this.sendRawRequest.perform(url, type, data, accept);

    if (response.status === 204 || response == null) {
      return;
    }

    const jsonResponse = await response.json();

    if (response.ok) {
      return jsonResponse;
    }

    const errorJson = jsonResponse.error;

    const error = new Error(errorJson?.message);
    error.contextVariables = errorJson?.contextVariables;
    error.isValidationError = errorJson?.isValidationError;
    throw error;
  }));

  getOptions(method, data, accept) {
    const options = {
      method,
      mode: 'cors',
      credentials: 'include',
      headers: {},
    };

    options.headers = { ...this.session.formattedHeaders };

    if (method !== 'DELETE') {
      options.headers.Accept = accept ?? 'application/json';

      if (method !== 'GET') {
        if (data instanceof FormData) {
          options.body = data;
        } else if (data != null) {
          options.headers['content-type'] = 'application/json';
          options.body = JSON.stringify(data);
        }
      }
    }

    return options;
  }

  getUrl(url, params = null) {
    url = `${config.servicePrefix}/${url}`;

    if (params != null) {
      Object.keys(params).forEach(key => {
        if (params[key] === undefined) {
          delete params[key];
        }
      });

      url = `${url}?${new URLSearchParams(params).toString()}`;
    }

    return url;
  }
}
